import {AbstractModel} from './abstract-model';

export class ApiPartnerToken extends AbstractModel {
  id: number | null = null;
  label: string | null = null;
  token: string | null = null;
  createdAt: Date | null = null;
  lastAccessAt: Date | null = null;
  subid: string | null = null;
  preping: boolean | null = null;
  hideReactivationResponseCode: boolean | null = null;
}
